import React from "react";
import TextField from "@material-ui/core/TextField/TextField";
import Typography from "@material-ui/core/Typography/Typography";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import { SalesDateRangesTable } from "../SalesDateRangesTable";
import { styles } from "./SalesSubscriptionAssignment.styles";

export interface ISalesSubscriptionAssignmentProps extends WithStyles<typeof styles> {
    selectedSubscriptionTypes: any[];
    addableSubscriptionTypes: any[];
    handleMultipleSubscriptionsSelection: (event: any, value: any) => void;
    tempDateRange: any[];
    handleEditDateRange: (index: any, newData: any) => void;
    handleAddDateRange: (newData: any) => void;
    handleDeleteFinished: () => void;
    isRequestingDateRanges: boolean;
}

const SalesSubscriptionAssignmentPure: React.FunctionComponent<ISalesSubscriptionAssignmentProps> = (
    {
        selectedSubscriptionTypes,
        addableSubscriptionTypes,
        handleMultipleSubscriptionsSelection,
        tempDateRange,
        handleEditDateRange,
        handleAddDateRange,
        handleDeleteFinished,
        isRequestingDateRanges,
        classes}: ISalesSubscriptionAssignmentProps) => {
    return (
        <div>
            <Typography variant="h4">Select subscriptions from the list</Typography>
            <Autocomplete
                classes={{
                    inputRoot: classes.aCInputRoot,
                    option: classes.aCOption,
                    listbox: classes.aCListbox
                }}
                id="multipleSubscriptionsSelect"
                multiple
                value={selectedSubscriptionTypes}
                options={addableSubscriptionTypes || []}
                getOptionLabel={(option: any) => option.name}
                renderInput={params => <TextField {...params} variant="outlined" placeholder="Select subscriptions" />}
                onChange={handleMultipleSubscriptionsSelection}
                getOptionSelected={(option, value) => option.subscriptionTypeId === value.subscriptionTypeId}
            />

            <Typography variant="h4" className={classes.bigTopMargin}>
                Add date range
            </Typography>
            <SalesDateRangesTable
                dateRanges={tempDateRange}
                handleEditDateRange={handleEditDateRange}
                handleAddDateRange={handleAddDateRange}
                handleDeleteFinished={handleDeleteFinished}
                isRequestingDateRanges={isRequestingDateRanges}
                oneDateRange={true}
            />
        </div>
    );
}

export const SalesSubscriptionAssignment = withStyles(styles)(SalesSubscriptionAssignmentPure);
